import $ from 'jquery';
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';
import Slider from '../../js/modules/Slider.mjs';
import {deviceIsMinMd} from '../../js/utilities/media-queries.mjs';

const $collectionSocialMedia = $('.ef-collection-social-media__social-content');
const $collectionSocialMediaWrapper = $('.ef-collection-social-media__social-content__wrapper', $collectionSocialMedia);
const $collectionSocialMediaSlide = $('.ef-collection-social-media__social-content__item', $collectionSocialMediaWrapper);
const $images = $collectionSocialMedia.find('.ef-collection-social-media__social-content__item-medium');
const $firstImage = $images.first();
const socialFeedElem = document.querySelector('.ef-collection-social-media__social-content__wrapper');
let iso = null;
let SliderCollectionSocialMedia;

$collectionSocialMedia.each(function() {
  var $socialWall = $(this);
  var socialFeedApiUrl = decodeURIComponent($socialWall.data('apiUrl'));

  $.getJSON(socialFeedApiUrl, function(data) {
    data.forEach((elem) => {
      createSocialWallElement(
          elem,
          decodeURIComponent($socialWall.data('imageUrl'))
      );
    });

    handleViewportSwitch(deviceIsMinMd);
    deviceIsMinMd.addListener(handleViewportSwitch);
  });
});

/**
 * @param {MediaQueryList} deviceIsMinMdMql
 */
function handleViewportSwitch(deviceIsMinMdMql) {
  if (deviceIsMinMdMql.matches) {
    // >medium
    if (SliderCollectionSocialMedia) {
      SliderCollectionSocialMedia.destroy();
    }

    $collectionSocialMedia.removeClass('swiper-container');
    $collectionSocialMediaWrapper.removeClass('swiper-wrapper');
    $collectionSocialMediaSlide.removeClass('swiper-slide');

    $images.each((index, image) => {
      const $image = $(image);
      const src = $image.attr('data-src');
      if (src) {
        $image.attr('src', src);
        $image.removeAttr('data-src')
      }
    });

    initIsotop();
  } else {
    if (iso) {
      iso.destroy();
    }
    // <medium

    $collectionSocialMedia.addClass('swiper-container');
    $collectionSocialMediaWrapper.addClass('swiper-wrapper');
    $collectionSocialMediaSlide.addClass('swiper-slide');

    $collectionSocialMedia.each((index, slider) => {
      SliderCollectionSocialMedia = new Slider({
        namespace: 'CollectionSocialMedia',
        sliderNode: slider,
        swiperConfigOverride: {
          autoHeight: true,
          preloadImages: false,
        }
      });

      SliderCollectionSocialMedia.init();
      $firstImage.on('load', () => {
        SliderCollectionSocialMedia.slider.swiper.updateAutoHeight();
      });
    });
  }
}

/*
 * Legacy code
 */
function initIsotop() {
  iso = new Isotope(socialFeedElem, {
    itemSelector: '.ef-collection-social-media__social-content__item',
    percentPosition: true,
    masonry: {
      columnWidth: '.ef-collection-social-media__social-content__item',
    },
  });

  imagesLoaded(socialFeedElem).on('progress', function() {
    // layout Isotope after each image loads
    // EFA-1843 call layout() with timeout to avoid issues with delayed rendering
    setTimeout(function() {
      iso.layout();
    }, 500);
  });
}

function createSocialWallElement(socialFeedElem, imageServerAndPath) {
  var channel = socialFeedElem.channel;

  switch (channel) {
    case 'facebook':
      var $facebook = $collectionSocialMedia.find('.js-facebook');
      if ($facebook) {
        $facebook.filter('.js-collection-social-media__link').attr('href', socialFeedElem.link);

        if (socialFeedElem.image === false) {
          $facebook.find('.ef-collection-social-media__social-content__item-medium').
              attr('src',
                  'typo3conf/ext/project/Resources/Public/Images/ernstings-family-logo3x.png');
        } else {
          $facebook.find('.ef-collection-social-media__social-content__item-medium').
              attr('src', imageServerAndPath + socialFeedElem.imageHqRetina);
        }
        $facebook.find('.ef-collection-social-media__social-content__item-text').html(socialFeedElem.text);
        $facebook.find('.ef-collection-social-media__social-content__item-date').html(convertTime(socialFeedElem));
        $facebook.find('.facebook-likes').html(socialFeedElem.likes);
      }
      break;
    case 'youtube':
      var $youtube = $collectionSocialMedia.find('.js-youtube');
      if ($youtube) {
        $youtube.filter('.js-collection-social-media__link').attr('href', socialFeedElem.link);
        $youtube.find('.ef-collection-social-media__social-content__item-medium').
            attr('data-src', imageServerAndPath + socialFeedElem.imageWallImage);
        $youtube.find('.ef-collection-social-media__social-content__item-text').html(socialFeedElem.titleNoTags);
        $youtube.find('.youtube-views').html(socialFeedElem.views);
        $youtube.find('.ef-collection-social-media__social-content__item-date').html(convertTime(socialFeedElem));
      }
      break;
    case 'pinterest':
      var $pinterest = $collectionSocialMedia.find('.js-pinterest');
      if ($pinterest) {
        $pinterest.filter('.js-collection-social-media__link').attr('href', socialFeedElem.link);
        $pinterest.find('.ef-collection-social-media__social-content__item-medium').
            attr('data-src', imageServerAndPath + socialFeedElem.imageWallImage);
        $pinterest.find('.ef-collection-social-media__social-content__item-title').html(socialFeedElem.title);
        $pinterest.find('.ef-collection-social-media__social-content__item-text').html(socialFeedElem.text);
        $pinterest.find('.pinterest-board').html(socialFeedElem.board);
      }
      break;
    case 'instagram':
      var $instagram = $collectionSocialMedia.find('.js-instagram');
      if ($instagram) {
        $instagram.filter('.js-collection-social-media__link').attr('href', socialFeedElem.link);
        $instagram.find('.ef-collection-social-media__social-content__item-medium').
            attr('data-src', imageServerAndPath + socialFeedElem.imageWallImage);
        $instagram.find('.ef-collection-social-media__social-content__item-text').html(socialFeedElem.text);
        $instagram.find('.ef-collection-social-media__social-content__item-date').html(convertTime(socialFeedElem));
      }
      break;
    default:
      // console.log("unknown channel");
      break;
  }
}

function convertTime(elem) {
  var date = elem.date;
  date = date.replace('Januar', '01.');
  date = date.replace('Februar', '02.');
  date = date.replace('März', '03.');
  date = date.replace('April', '04.');
  date = date.replace('Mai', '05.');
  date = date.replace('Juni', '06.');
  date = date.replace('Juli', '07.');
  date = date.replace('August', '08.');
  date = date.replace('September', '09.');
  date = date.replace('Oktober', '10.');
  date = date.replace('November', '11.');
  date = date.replace('Dezember', '12.');
  date = date.replace(/ /g, '');
  return date;
}
